// extracted by mini-css-extract-plugin
module.exports = {"pill":"pill_pill__jrsfQ","error":"pill_error__3HHXI","icon":"pill_icon__2GBYU"};